import { Component, ChangeDetectionStrategy, ElementRef, Input } from '@angular/core';

import { SnBaseButtonComponent } from '../../base/base-button.component';

@Component({
  selector: 'sn-text-icon-button',
  templateUrl: './text-icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  inputs: ['disabled', 'color', 'tabIndex', 'type', 'isLoading'],
  host: {
    class: 'sn-text-icon-button',
    '[class.loading]': 'isLoadingState',
    '[attr.disabled]': 'isDisabledState',
  },
})
export class SnTextIconButtonComponent extends SnBaseButtonComponent {
  @Input() public icon: string;
  @Input() public label: string;
  @Input() public labelPosition: 'left' | 'right' = 'right';
  @Input('aria-label') public ariaLabel: string;

  constructor(elementRef: ElementRef<HTMLElement>) {
    super(elementRef);
  }

  get isDisabledState(): boolean {
    return this.disabled || this.isLoading;
  }

  get isLoadingState(): boolean {
    return this.isLoading && !this.disabled;
  }
}
